import React from "react"
import { CardElement as _CardElement } from "react-stripe-elements"
import styled from "styled-components"

import { EyebrowSmall } from "components/text"
import * as Input from "components/form/shared/default-field/styles"
import { TEST_MARKER_CONSTANTS } from "shared/test-selectors"
import theme from "theme"

export const styles = {
  base: {
    padding: "1rem 1.5rem",
    color: theme.colors.evergreen,
    fontFamily: theme.fonts.paragraph,
    fontSmoothing: "antialiased",
    fontSize: "16px",
    lineHeight: "1.75",
    "::placeholder": {
      color: theme.colors.silverDark,
      fontFamily: theme.fonts.mono,
      fontSize: "0.875rem",
      lineHeight: "1",
      letterSpacing: "1.25px",
      fontWeight: "normal",
      textTransform: "uppercase"
    },
    ":focus": {
      color: theme.colors.evergreen
    }
  },
  invalid: {
    color: theme.colors.salmon,
    iconColor: theme.colors.salmon
  }
}

const Label = styled(EyebrowSmall)`
  position: absolute;
  font-size: 10px;
  transform: translateY(-${props => props.theme.space[4]});
`

export const CardElement = () => (
  <Input.Box py={[4, 4, 4, 4]} px={[5, 5, 5, 5]} position="relative" data-test={TEST_MARKER_CONSTANTS.CARD_ELEMENT}>
    <Label>Credit Card</Label>
    <_CardElement style={styles} hidePostalCode iconStyle="solid" />
  </Input.Box>
)
